import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// Basic tooltip with arrows.
// Arrows supported for top bottom left and right positions.
// Props:
// tipText: Type string. Sets tooltip label
// placement: Type string. Sets position of tooltip
//           top, bottom, left, right

const styles = (theme) => ({
    button: {
        margin: theme.spacing(1)
    },
    arrowPopper: arrowGenerator(theme.palette.grey[700]),
    arrow: {
        position: 'absolute',
        fontSize: 10,
        width: '3em',
        height: '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid'
        }
    },
    tooltip: {
        fontSize: '1rem'
    }
});

function arrowGenerator(color) {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.95em',
            width: '3em',
            height: '1em',
            borderColor: 'white',
            borderWidth: '1px',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${color} transparent`
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.95em',
            width: '3em',
            height: '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${color} transparent transparent transparent`
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.95em',
            height: '2em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${color} transparent transparent`
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.95em',
            height: '2em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${color}`
            }
        }
    };
}

class DrcTooltip extends React.Component {
    state = {
        arrowRef: null
    };

    handleArrowRef = (node) => {
        this.setState({
            arrowRef: node
        });
    };
    render() {
        const { tipText, placement, classes, ...other } = this.props;
        return (
            <Tooltip
                {...other}
                title={
                    <React.Fragment>
                        {tipText}
                        {/*<span className={classes.arrow} ref={this.handleArrowRef} />*/}
                    </React.Fragment>
                }
                placement={placement}
                classes={{
                    popper: classes.arrowPopper,
                    tooltip: classes.tooltip
                }}
                /*PopperProps={{
                    popperOptions: {
                        modifiers: {
                            arrow: {
                                enabled: Boolean(this.state.arrowRef),
                                element: this.state.arrowRef
                            }
                        }
                    }
                }}*/
                disableFocusListener={!tipText || tipText.length <= 0}
                disableHoverListener={!tipText || tipText.length <= 0}
                disableTouchListener={!tipText || tipText.length <= 0}
            >
                {this.props.children}
            </Tooltip>
        );
    }
}

DrcTooltip.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DrcTooltip);
